import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { formatLocalDate } from "../utils/dateUtils";

const TopDeals = ({ deals }) => {
  const navigate = useNavigate();
  if (!deals || deals.length === 0) return null; //. prevents rendering if no data

  const badgeLabel = (badge) =>
    badge
      ? badge.discount_type === "percent"
        ? `${badge.discount_value}% OFF`
        : `₹${Math.round(badge.discount_value)} OFF`
      : null;

  return (
    <section className="topcontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="section-heading d-flex justify-content-between align-items-center"
              data-aos="zoom-in"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="1000"
            >
              <h2>
                Top Homestays
              </h2>
              {/* <a href="#" className="theme-btn">
                View All
              </a> */}
              <button
                onClick={() => {
                  // stays/list filters everything out when checkin/checkout
                  // are missing (its availability check is a date-range
                  // BETWEEN clause) — without dates, "View All" always came
                  // back with zero results. Default to tomorrow/day-after,
                  // the same fallback BannerSearch itself uses.
                  const tomorrow = new Date();
                  tomorrow.setDate(tomorrow.getDate() + 1);
                  const dayAfter = new Date();
                  dayAfter.setDate(dayAfter.getDate() + 2);

                  navigate('/stays', {
                    state: {
                      page: 1,
                      limit: 10,
                      checkin_date: formatLocalDate(tomorrow),
                      checkout_date: formatLocalDate(dayAfter),
                      adults: 1,
                      kids: 0,
                      rooms_required: 1
                    }
                  });
                }}
                className="theme-btn"
              >
                View All
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12" data-aos="fade-up" data-aos-duration="500">


            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={700}
              slidesPerView={1}
              spaceBetween={15}
              pagination={false}
              navigation={{
                nextEl: ".swiper-button-next-top-deal",
                prevEl: ".swiper-button-prev-top-deal",
              }}
              breakpoints={{
                100: { slidesPerView: 2.6, spaceBetween: 5 },
                321: { slidesPerView: 2.6, spaceBetween: 5 },
                574: { slidesPerView: 2.6, spaceBetween: 5 },
                768: { slidesPerView: 3.4, spaceBetween: 10 },
                992: { slidesPerView: 4.2, spaceBetween: 15 },
                1200: { slidesPerView: 4.6, spaceBetween: 20 },
                1400: { slidesPerView: 5, spaceBetween: 20 },
              }}
              loop={false}
            >
              {deals.map((deal, index) => (
                <SwiperSlide key={index}>
                  <div className="topdealbx">
                    <div className="topdealimg">
                      {deal.promo_badge && (
                        <span className="promo-badge">
                          <span className="promo-dot"></span>
                          {badgeLabel(deal.promo_badge)}
                        </span>
                      )}
                      <span className="startp">
                        <i className="fa fa-star"></i>
                        <span>{deal.rating ?? 0}</span>
                      </span>
                      <Link to={`/property/${deal.id}`}>
                        <img
                          src={deal?.cover_image ? deal.cover_image : "/guestlinkup/images/nhii.png"}
                          alt={deal?.title || "Property image"}
                        />
                      </Link>


                    </div>
                    <div className="topdealcontent">
                      <h3 onClick={() => navigate(`/property/${deal.id}`)}>
                        <a href="#">{deal.title}</a>
                      </h3>
                      <p>{deal.description}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* External Pagination and Navigation */}
            <div className="d-flex justify-content-center">
              <div className="swiper-pagination swiper-pagination-top-deal"></div>
            </div>
            <div className="swiper-nav">
              <div className="swiper-button-prev swiper-button-prev-top-deal"></div>
              <div className="swiper-button-next swiper-button-next-top-deal"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopDeals;
